export default "__VITE_ASSET__C7bEWNQ6__"